/**
 * MIME types for downloaded files. `binary` is the fallback for user-supplied
 * resources whose type is not known ahead of time.
 */
export const MIME_TYPES = {
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
  json: 'application/json',
  binary: 'application/octet-stream',
};

/**
 * Shared browser file-download helper.
 * @param {Blob} blob - The blob to download
 * @param {string} fileName - The file name offered to the user
 */
export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
